import { render, staticRenderFns } from "./DealsGridView.vue?vue&type=template&id=0b6170ea&"
import script from "./DealsGridView.vue?vue&type=script&lang=js&"
export * from "./DealsGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports